import Vue from 'vue'
import router from '@/router'
import { 
    apiBizRegister,
    apiBizCheckVerified,
    apiBizLogin,
    apiBizGetUserInfo,
    apiBizGetRoleAccess,
} from "@/apis/api.js"; 
import { 
    sendLoginLog,
} from "@/apis/global/log.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    auth_request: 'bizUser/auth_request',
    auth_error: 'bizUser/auth_error',
    auth_success: 'bizUser/auth_success',
    logout: 'bizUser/logout',
    set_user_info: 'bizUser/set_user_info',
    set_role_access: 'bizUser/set_role_access',
    set_verified_bling: 'bizUser/set_verified_bling',
}

// count state 必須是 Object
const state = {
    status: '',
    token: localStorage.getItem('token') || '',
    userInfo: null,
    userRoleAccess: null,
    verifiedBlingStatus: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    isBizLoggedIn: state => !!state.token,
    // 會員資料
    GET_BIZ_USER_INFO: (state) => {
        return state.userInfo?state.userInfo:null
    },
    GET_BIZ_USER_ACCOUNT: (state) => {
        return state.userInfo?state.userInfo.account:null
    },
    GET_BIZ_USER_AUTO_SIGN: (state) => {
        return state.userInfo?state.userInfo.autoSign:null
    },
    GET_BIZ_USER_COMPANY_ID: (state) => {
        return state.userInfo?state.userInfo.companyId:null
    },
    GET_BIZ_USER_GROUP_ID: (state) => {
        return state.userInfo?state.userInfo.groupId:null
    },
    GET_BIZ_USER_MEMBER_TYPE: (state) => {
        return state.userInfo?state.userInfo.memberType:null
    },
    GET_BIZ_USER_ROLE_CODE: (state) => {
        return state.userInfo?state.userInfo.roleName:null
    },
    GET_BIZ_COMPANY_IS_VERIFIED: (state) => {
        return state.userInfo?state.userInfo.companyAuditStatus:null
    },
    // 權限
    GET_BIZ_AUTH: (state) => {
        return state.userRoleAccess?state.userRoleAccess:null
    },
    // 是否為全部群組
    GET_BIZ_IS_ALL_GROUP: (state) => {
        if(state.userInfo && state.userInfo.groupCode == 'WHOLE_COMPANY_GROUP'){
            return true
        }else{
            return false
        }
    },
    // 取得群組ID
    GET_BIZ_GROUP_ID: (state) => {
        return state.userInfo?state.userInfo.groupId:null
    },
    // 取得群組名稱
    GET_BIZ_GROUP_NAME: (state) => {
        return state.userInfo?state.userInfo.groupName:null
    },
    // 取得使用者名稱
    GET_BIZ_USER_NAME: (state) => {
        return state.userInfo?state.userInfo.userName:null
    },
    // 認證提醒active畫面
    GET_BIZ_VERIFIED_BLING: (state) => {
        return state.verifiedBlingStatus
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    bizLogin({commit, dispatch}, user){
        return new Promise((resolve, reject) => {
            commit(types.auth_request)
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
            localStorage.removeItem('userState')
            apiBizLogin(user)
            .then(res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    // console.log(res.data.result.access_token)
                    let token = res.data.result.access_token;
                    let refreshToken = res.data.result.refresh_token;
                    // localStorage.setItem('token', token)
                    let loginRes = res;
                    commit(types.auth_success, token)
                    // console.log(Vue.prototype.checkLocalStorageHasVal('token', token))
                    if(Vue.prototype.checkLocalStorageHasVal('token', token) && Vue.prototype.checkLocalStorageHasVal('refreshToken', refreshToken)){
                        dispatch('bizSendLoginLog', 'WEB_COMPANY')
                        // 取得會員資料
                        dispatch('bizGetUserInfo')
                        .then( ()=>{
                            // 導頁
                            resolve(loginRes);
                        }).catch(err => {
                            reject(err)
                            // error TODO
                        })
                    }
                    
                }else{
                    commit(types.auth_error)
                    localStorage.removeItem('token')
                    if(res.data.errorCode == 221018 || res.data.errorCode == 221033){
                        reject('accountErr')
                    }else if(res.data.errorCode == 221022){
                        reject('noAccount')
                    }else if(res.data.errorCode == 222009){
                        reject('verifyErr')
                    }else{
                        reject(res.data.errorMsg)
                    }
                }
                
            })
            .catch(err => {
                commit(types.auth_error)
                localStorage.removeItem('token')
                reject(err)
            })
        })
    },
    bizRegister({commit, dispatch}, user){
        return new Promise((resolve, reject) => {
            commit(types.auth_request)
            apiBizRegister(user)
            .then(res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    resolve(res)
                }else{
                    reject(res)
                }
            })
            .catch(err => {
                commit(types.auth_error, err)
                localStorage.removeItem('token')
                reject(err)
            })
        })
    },
    bizSendLoginLog ( {commit, dispatch}, loginFrom ) {
        return new Promise((resolve, reject) => {
            const data = {
                loginFrom: loginFrom,
                model: Vue.prototype.getBrowser(),
                version: Vue.prototype.getSys(),
            }
            console.log(data)
            sendLoginLog(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                }
            })
            .catch(err => {
            })
        })
    },
    verification({commit, dispatch}, data){
        return new Promise((resolve, reject) => {
            commit(types.auth_request)
            apiBizCheckVerified(data)
            .then(res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    const token = res.data.result.access_token
                    localStorage.setItem('token', token)
                    resolve()
                    // arkPayRequest.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    // commit(types.auth_verification, token)
                }else if(res.data.status == 'FAIL'){
                    // commit(types.auth_verification, '')
                    // commit(types.auth_error, res.data.errorMsg)
                    reject()
                }
            })
            .catch(err => {
                commit(types.auth_error, err)
                reject(err)
            })
        })
    },
    bizLogout({commit, dispatch}){
        return new Promise((resolve, reject) => {
            commit(types.logout)
            localStorage.removeItem('token')
            localStorage.removeItem('userState')
            router.push({name: 'bizLogin'})
            resolve()
        })
    },
    bizGetUserInfo({commit, dispatch}){
        return new Promise((resolve, reject) => {
            apiBizGetUserInfo()
            .then(res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    commit(types.set_user_info, res.data.result)
                    if(res.data.result.companyAuditStatus == 'NOT_AUDITS'){
                        window.location = '/enterprise/bizVerified'
                    }else{
                        // 取得角色權限
                        dispatch('bizGetRoleAccess')
                        .then( res =>{
                            resolve(res);
                        })
                        .catch(err => {
                            reject(err)
                            dispatch('setAlarmStatus', {status: true,title: '系統發生未預期錯誤，請再試一次',type: 'error'})
                            // error TODO
                        })
                    }
                    
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                // other status TODO
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: '系統發生未預期錯誤，請再試一次',type: 'error'})
                reject(err)
                // error TODO
            })
        })
    },
    bizGetRoleAccess({commit, dispatch}, data){
        return new Promise((resolve, reject) => {
            apiBizGetRoleAccess(data)
            .then(res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    commit(types.set_role_access, res.data.result)
                    resolve(res)
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    // other status TODO
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: '系統發生未預期錯誤，請再試一次',type: 'error'})
                reject(err)
                // error TODO
            })
        })
    },
    bizSetVerifiedAlarmBling({commit, dispatch}, time){
        return new Promise((resolve, reject) => {
            commit(types.set_verified_bling, true)
            setTimeout(()=>{
                commit(types.set_verified_bling, false)
            }, time)
        })
    },
}

// mutations
const mutations = {
    [types.auth_request](state){
        state.status = 'loading'
    },
    [types.auth_error](state){
        state.status = 'error'
    },
    [types.auth_success](state, token){
        state.status = 'success'
        state.token = token
    },
    [types.logout](state){
        state.status = ''
        state.token = ''
    },
    [types.set_user_info](state, data){
        state.userInfo = data
    },
    [types.set_role_access](state, data){
        state.userRoleAccess = data
    },
    [types.set_verified_bling](state, data){
        state.verifiedBlingStatus = data
    }
    
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/bizUser.js